/**
 * Basemaps — spec §F5.1 ("Basemaps: light `basemaps.cartocdn.com/light_all`, streets OSM,
 * satellite Esri World_Imagery, terrain OpenTopoMap").
 *
 * URLs, attributions, display names and thumbnail swatches are copied verbatim from the
 * mockup's `BASEMAPS` object (plan Global Constraints: the mockup wins on look). The keys
 * are the §F1 `AppState.basemap` union, so the store field indexes this record directly.
 */
import type { Basemap } from '../../lib/state';

export interface BasemapDef {
  /** Label shown in the §F5.10 basemap panel (M2). */
  name: string;
  url: string;
  attr: string;
  /** Swatch colour for the basemap panel's thumb (mockup `.bm-thumb`). */
  thumb: string;
}

export const BASEMAPS: Record<Basemap, BasemapDef> = {
  light: {
    name: 'Light (Carto)',
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attr: '© OpenStreetMap © CARTO',
    thumb: '#E8EAE6',
  },
  streets: {
    name: 'Streets (OSM)',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attr: '© OpenStreetMap contributors',
    thumb: '#DCE8CF',
  },
  satellite: {
    name: 'Satellite (Esri)',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attr: 'Esri, Maxar, Earthstar Geographics',
    thumb: '#3D4A33',
  },
  terrain: {
    name: 'Terrain (OpenTopo)',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attr: '© OpenTopoMap (CC-BY-SA)',
    thumb: '#D8CBA8',
  },
};

/** Ordered keys — the panel and the tests iterate this, never `Object.keys`. */
export const BASEMAP_KEYS = ['light', 'streets', 'satellite', 'terrain'] as const;
